import { render, staticRenderFns } from "./ProductionSwitcherPopoverItem.vue?vue&type=template&id=36bfa2fa&"
import script from "./ProductionSwitcherPopoverItem.vue?vue&type=script&lang=js&"
export * from "./ProductionSwitcherPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports